export const aciArrowCarrouselRight = {
    iconName: 'arrow-carrousel-right',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        defs: {
            clipPath: {
                attr: { id: 'clip0_35048_1863' },
                path: {
                    attr: {
                        fill: 'currentColor',
                        transform: 'rotate(-90 12.223 4.223)',
                        d: 'M0 0h8.889v7.556H0z',
                    },
                },
            },
        },
        path: {
            attr: {
                'clip-path': 'url(#clip0_35048_1863)',
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M10.568 15.256a.5.5 0 010-.707l2.771-2.772-2.77-2.771a.5.5 0 01.706-.707l2.978 2.977a.707.707 0 010 1.002l-2.978 2.978a.5.5 0 01-.707 0zm2.978-3.272zm0-.413z',
                fill: 'currentColor',
            },
        },
    },
};
